export default [
  {
    path: '/perfil',
    name: 'DetalhesPerfil',
    component: () => import('@/views/DetalhesPerfil.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/pedidos',
    name: 'MeusPedidos',
    component: () => import('@/views/MeusPedidos.vue'),
    meta: { requiresAuth: true }
  }
]
